import { render, staticRenderFns } from "./SelectWidget.vue?vue&type=template&id=256f72a3&lang=pug&"
import script from "./SelectWidget.vue?vue&type=script&lang=js&"
export * from "./SelectWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports